import { render, staticRenderFns } from "./CalendarTasks.vue?vue&type=template&id=d1819b78"
import script from "./CalendarTasks.vue?vue&type=script&lang=js"
export * from "./CalendarTasks.vue?vue&type=script&lang=js"
import style0 from "./CalendarTasks.vue?vue&type=style&index=0&id=d1819b78&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports